import { render } from "./OpenApplication.vue?vue&type=template&id=80aa1774&scoped=true"
import script from "./OpenApplication.vue?vue&type=script&lang=js"
export * from "./OpenApplication.vue?vue&type=script&lang=js"

import "./OpenApplication.vue?vue&type=style&index=0&id=80aa1774&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80aa1774"]])

export default __exports__